import { useEffect, useState } from 'react';
import { obtenerCustodiaPorId, obtenerListadoCustodiaPorFecha } from '../../services/Custodia/CustodiaService';
import { obtenerConfiguracionDet } from '../../services/Configuracion/ConfiguracionDetService';
import { ESTADO_CREADO_CODE, ESTADO_CUSTODIA_CAB_CODE } from './data/custodiaDicctionary';

export const useCustodia = () => {
    const [fecha, setFecha] = useState('');
    const [custodiaData, setCustodiaData] = useState(null);
    const [custodiaSelected, setCustodiaSelected] = useState(null);
    const [estadoCustodia, setEstadoCustodia] = useState(null);
    const [loadTrazabilidadHistory, setLoadTrazabilidadHistory] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [subirFotoTrazabilidad, setSubirFotoTrazabilidad] = useState(null);

    const onChangeFecha = (e) => {
        setFecha(e.value);
    };

    useEffect(() => {
        if (fecha) {
            obtenerListadoCustodia(fecha);
        }
    }, [fecha]);

    useEffect(() => {
        loadEstadoCustodia();
    }, []);

    const loadEstadoCustodia = async () => {
        // Lógica para cargar estados de custodia desde una API o fuente de datos
        // Simulación de carga
        try {
            const response = await obtenerConfiguracionDet(ESTADO_CUSTODIA_CAB_CODE);
            setEstadoCustodia(response);
        } catch (error) {
            console.error('Error loading estado custodia:', error);
        }
    };

    const convertirFechaAISO = (fecha, includeTime = true) => {
        //validar si la fecha es nula o vacia
        if (!fecha) return null;
        const fechaISO = new Date(fecha);
        const year = fechaISO.getFullYear();
        const month = String(fechaISO.getMonth() + 1).padStart(2, '0');
        const day = String(fechaISO.getDate()).padStart(2, '0');
        const hours = String(fechaISO.getHours()).padStart(2, '0');
        const minutes = String(fechaISO.getMinutes()).padStart(2, '0');
        const seconds = String(fechaISO.getSeconds()).padStart(2, '0');
        return includeTime ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` : `${year}-${month}-${day}`;
    };

    const obtenerListadoCustodia = async (fecha) => {
        try {
            const userid = localStorage.getItem('userId');
            setIsLoading(true);
            const fechaFormateada = convertirFechaAISO(fecha);
            const response = await obtenerListadoCustodiaPorFecha(fechaFormateada, userid);
            setCustodiaData(
                response.data.map((custodia) => ({
                    ...custodia,
                    cliente: custodia.cliente || { nombre: custodia.nombreCliente }
                }))
            );
        } catch (error) {
            console.error('Error loading custodia data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const onStartCreateCustodia = () => {
        const userId = localStorage.getItem('userId');
        const estadoActual = estadoCustodia.find((e) => e.codigo === ESTADO_CREADO_CODE);
        ///tomar fecha seleccionada y hora actual
        const fechaActualConHora = new Date();

        setCustodiaSelected({ fechaCreacion: fechaActualConHora, estado: estadoActual?.configuracionDetId, estadoCode: estadoActual?.codigo, usuarioCreacionId: Number(userId) });
    };

    const fromISOToDate = (isoString) => {
        // validar isoString nulo
        if (!isoString) return null;
        // Si la fecha viene solo como YYYY-MM-DD (sin hora), agregamos "T00:00:00"
        // y forzamos interpretación local con split manual
        if (isoString?.length === 10 && isoString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [year, month, day] = isoString.split('-').map(Number);
            // Nota: month - 1 porque Date usa meses 0-11
            return new Date(year, month - 1, day);
        }

        // Si ya incluye hora, usar el constructor normal
        return new Date(isoString);
    };

    const onStartEditCustodia = async (custodia) => {
        try {
            const response = await obtenerCustodiaPorId(custodia.id);
            const { data } = response;
            const parseResponse = parseCustodiaData(data);

            setCustodiaSelected(parseResponse);
        } catch (error) {
            console.error('Error al iniciar la edición de la custodia:', error);
        }
    };

    const parseCustodiaData = (data) => {
        const parseResponse = {
            id: data.id,
            fechaCreacion: fromISOToDate(data.fechaCreacion),
            fechaInicio: fromISOToDate(data.fechaInicio),
            fechaFin: fromISOToDate(data.fechaFin),
            estado: data.estado.id,
            estadoCode: data.estado.codigo,
            clienteId: data.cliente?.id,
            origen: data.origen,
            destino: data.destino,
            usuarioCreacionId: data.usuarioCreacion.id,
            nombreCliente: data.nombreCliente,
            correoElectronicoCliente: data.correoElectronicoCliente ? data.correoElectronicoCliente.split(';') : [],
            patrullas: data.patrullas.map((p) => ({
                ...p,
                integrantes: p.integrantes.map((i) => ({
                    ...i,
                    tipo: i.tipo.id
                }))
            })),
            custodiados: data.custodiados.map((c) => ({
                ...c,
                componentes: c.componentes.map((comp) => ({
                    ...comp,
                    tipo: comp.tipo.id
                }))
            }))
        };
        return parseResponse;
    };

    const onSuccessSave = (data) => {
        obtenerListadoCustodia(fecha);
        const parsedData = parseCustodiaData(data);
        setCustodiaSelected(parsedData);
    };

    return {
        estadoCustodia,
        fecha,
        onChangeFecha,
        custodiaData,
        custodiaSelected,
        setCustodiaSelected,
        onStartCreateCustodia,
        onStartEditCustodia,
        loadTrazabilidadHistory,
        setLoadTrazabilidadHistory,
        convertirFechaAISO,
        onSuccessSave,
        isLoading,
        subirFotoTrazabilidad,
        setSubirFotoTrazabilidad,
        recargarLista: () => {
            if (fecha) obtenerListadoCustodia(fecha);
        }
    };
};
